import { useTranslation } from 'react-i18next'
import React, { ReactNode } from 'react'
import './notification.css'
import { useNavigate } from 'react-router-dom'
import { BellIcon, CheckIcon, ErrorIcon, InfoIcon, DefaultIcon } from '../../containers/icons/icons'

interface NotificationProps {
  title?: string
  message?: string
  type?: 'default' | 'success' | 'warning' | 'error' | 'info'
  onClose?: () => void
  children?: ReactNode
}

const Notification: React.FC<NotificationProps> = ({ title, message, type = 'default', onClose, children }) => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()

  const handle = {
    dismissNotification: () => {
      if (onClose) onClose()
    },
    upgrade: () => {
      navigate('/settings#plan')
    },
  }

  const getIcon = () => {
    switch (type) {
      case 'warning':
        return <BellIcon />
      case 'success':
        return <CheckIcon />
      case 'error':
        return <ErrorIcon />
      case 'info':
        return <InfoIcon />
      default:
        return <DefaultIcon />
    }
  }

  return (
    <div className={`notification notification-${type}`}>
      <div className={`notification-icon notification-icon-${type}`}>{getIcon()}</div>
      <div className='notification-content'>
        {title && <div className='notification-title'>{title}</div>}
        {children ? (
          <div className='notification-message'>{children}</div>
        ) : (
          message && <div className='notification-message'>{message}</div>
        )}
      </div>
      <button className='notification-close' onClick={handle.dismissNotification} aria-label={t('closeNotification')}>
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M12 4L4 12M4 4L12 12' stroke='#000' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </button>
    </div>
  )
}

export default Notification
